// extracted by mini-css-extract-plugin
module.exports = {"section":"BenefitsSections-section_51f83f6d","benefits":"BenefitsSections-benefits_e3fecb4b"};